import { render, staticRenderFns } from "./templateFooter.vue?vue&type=template&id=559e652a&scoped=true"
import script from "./templateFooter.vue?vue&type=script&lang=js"
export * from "./templateFooter.vue?vue&type=script&lang=js"
import style0 from "./templateFooter.vue?vue&type=style&index=0&id=559e652a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e652a",
  null
  
)

export default component.exports